// extracted by mini-css-extract-plugin
export default {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__IVnDJ","success":"FinishedQuiz_success__c8Dur","error":"FinishedQuiz_error__YUMxW"};